module.exports = __webpack_public_path__ + "img/academic.fb077809.svg";